function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 7a6 6 0 116 6 6.008 6.008 0 01-6-6zm1.2 0a4.8 4.8 0 109.6 0 4.8 4.8 0 00-9.6 0z",
  fill: "currentColor"
});

var SvgInactive = function SvgInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgInactive;